const TINTS = {
  'elevation-1': 0.05,
  'elevation-2': 0.08,
  'elevation-3': 0.11,
  'elevation-4': 0.12,
  'elevation-5': 0.14,
  hover: 0.08,
  focus: 0.12,
  pressed: 0.12,
  dragged: 0.16,
} as const;

export const ALL_TINTS = Object.entries(TINTS) as [
  Tint,
  (typeof TINTS)[Tint],
][];

export type Tint = keyof typeof TINTS;

type getElevationKeys<T extends Tint> =
  T extends `elevation-${infer S extends number}` ? S : never;

export type Elevation = getElevationKeys<Tint>;

const tintName = <T extends Tint>(tint: T) => `--theme-${tint}-tint` as const;

export const tintVar = <T extends Tint>(tint: T) =>
  `var(${tintName(tint)})` as const;

export default ALL_TINTS.map(
  ([name, value]) => `${tintName(name)}: ${value};`
).join('');
